import { render, staticRenderFns } from "./BillingAccountDetails.vue?vue&type=template&id=b88637f0&scoped=true&"
import script from "./BillingAccountDetails.vue?vue&type=script&lang=js&"
export * from "./BillingAccountDetails.vue?vue&type=script&lang=js&"
import style0 from "./BillingAccountDetails.vue?vue&type=style&index=0&id=b88637f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88637f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b88637f0')) {
      api.createRecord('b88637f0', component.options)
    } else {
      api.reload('b88637f0', component.options)
    }
    module.hot.accept("./BillingAccountDetails.vue?vue&type=template&id=b88637f0&scoped=true&", function () {
      api.rerender('b88637f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Billing/BillingAccountDetails.vue"
export default component.exports